/* eslint-env browser */
import { Component, Input, OnInit,  OnDestroy, ChangeDetectorRef, ComponentRef, ViewContainerRef, input, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TvangebotimagevideoComponent } from '@app/components/modals/tvangebotimagevideo/tvangebotimagevideo.component';
import { Customer } from '@app/models/customers/Customer';
import { CommonOffer } from '@app/models/offers/CommonOffer';
import { VerifyResponse } from '@app/models/offers/VerifyResponse';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { formatNumber } from '@angular/common';
import { NavigationExtras, Router } from '@angular/router';
import { EncryptionService } from '@app/services/encyption.service';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { FlugDetailComponent } from '@app/components/modals/flugdetail/flugdetail.component';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import moment from 'moment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { SktvDetailComponent } from '../offerpackdetailmodal/sktv-detail/sktv-detail.component';
import { TrafficsService } from '@app/services/traffics.service';

@Component({
    selector: 'app-offerpackssktvcard',
    templateUrl: './offerpackssktvcard.component.html',
    styleUrls: ['./offerpackssktvcard.component.scss'],
    standalone: false
})
export class OfferpackssktvcardComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject();
    readonly sktvContent = input<any>(undefined);
    readonly index = input<number>(undefined);
    readonly reference = input<string>(undefined);
    readonly mode = input<string>(undefined);
    readonly offerid = input<string>(undefined);
    @Input() offer: CommonOffer;
    readonly currentCustomer = input<Customer>(undefined);
    @Input() booking: VerifyResponse;
    readonly categoryAr = input([]);
    readonly title = input<string>(undefined);
    readonly removeFromList = output<string>();
    readonly saveImagePos = output<number>();
    readonly changeindex = output<{
        dragedindex: number;
        dropindex: number;
    }>();
    readonly openSetComment = output<boolean>();
    showAlternative: boolean = false;
    firstBilderPos: number = 0;
    desktopTemplate: string;
    travelerText: string = '';
    partnerid: string = '';
    prcdetail: string = '';

    component: ComponentRef<any>;
    sendRegSub: Subscription;
    sendBook: Subscription;
    showDetail: boolean = false;
    checkloading: boolean = true;
    constructor(
        protected dialog: MatDialog,
        protected encservice: EncryptionService,
        protected router: Router,
        protected cdr: ChangeDetectorRef,
        protected viewContainerRef: ViewContainerRef,
        protected guardService: AuthGuardService,
        protected trafficsService: TrafficsService,
        protected mediaObserver: BreakpointObserver
    ) {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
    }

    ngOnInit(): void {
        // console.log(this.offer)
        this.initPartner();
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(partner => {
            this.partnerid = partner?.partnerid;
            if (this.partnerid?.length > 0) {
                this.initData();
                this.checkOffer();
            }
        });
    }

    async checkOffer() {
        if (this.booking.commonOffer?.code?.length > 0) {
            this.checkloading = true;
            let childtrenages = '';
            let adults = 0;
            for (let i = 0; i < this.booking.travellerList?.length; i++) {
                if (this.booking.travellerList[i].type === 'K' || this.booking.travellerList[i].type === 'B') {
                    if (childtrenages?.length > 0) {
                        childtrenages += ',' + this.booking.travellerList[i].age;
                    } else {
                        childtrenages += this.booking.travellerList[i].age;
                    }
                } else {
                    adults++;
                }
            }

            const target = {
                data: {
                    code: this.booking.commonOffer.code,
                    adults: adults,
                    children: childtrenages,
                    rooms: '', // 3 rooms must be like : [{adults:2},{adults:1},{children:2}]
                    type: 'full',
                    optionAlternativeFlightOfferList: false,
                },
                mode: this.booking.mode,
                extra: this.booking.extra,
                insertOffer: true
            };

            this.trafficsService.request(target, 'offers/code').pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res) => {
                this.checkloading = false;
                const tmp_reference = this.booking.reference;
                if (!res.error) {
                    if (res.statusCode === 'OK' || res.statusCode === 'RQ') {
                        this.booking = res;
                        this.booking.reference = tmp_reference;
                    } else {
                        this.showAlternative = true;
                    }
                }
                this.initData();
                this.cdr.detectChanges();
            });
        }
    }


    async setCommentModal() {
        this.openSetComment.emit(true);
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();

        this.sendRegSub?.unsubscribe();
        this.sendBook?.unsubscribe();
    }

    async initData() {
        let countEr = 1;
        let kind = 0;
        let erw = 0;
        for (let i = 0; i < this.booking?.travellerList?.length; i++) {
            let prc = ''
            if (this.booking.travellerList[i].price?.value?.length > 0) {
                prc = formatNumber(Number(this.booking.travellerList[i].price?.value), 'de-DE', '1.2-2');
            } else {
                if (this.booking.travellerList[i].type === 'H') {
                    prc = formatNumber(Number(this.booking.pricePerPerson?.value), 'de-DE', '1.2-2');
                } else {
                    prc = '?';
                }
            }
            if (prc?.length > 0) {
                if (this.booking.travellerList[i].type === 'H') {
                    this.prcdetail += countEr + '.Erwachsener ' + prc + ' EUR\n';
                    countEr++;
                    erw += 1;
                } else {
                    this.prcdetail += countEr + '.Kinder ' + prc + ' EUR\n';
                    countEr++;
                    kind += 1;
                }
            }
        }
        if (erw > 0) {
            this.travelerText = erw + ' Erwachsene';
        }
        if (kind > 0) {
            this.travelerText += ', ' + kind + ' Kinder';
        }
        this.cdr.detectChanges();
    }

    async removeFromListF() {
        this.removeFromList.emit(this.offerid());
    }

    async goToBooking() {
        if (this.booking?.offerid?.length > 0) {
            const realparams = {
                offerid: this.booking?.offerid,
                productType: this.booking?.mode,
                reference: this.reference()?.length > 0 ? this.reference() : 'offerpack'
            };
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt(realparams) }
            };
            const url = this.router.createUrlTree(['booking'], navigationExtras).toString();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('visibility', 'hidden');
            link.click();
        }
    }

    async gotoOffers() {
        const sktvContent = this.sktvContent();
        if (this.booking?.realparams) {
            this.booking.realparams.reisezeitraumResult = {
                start: moment(this.booking?.commonOffer?.hotelOffer?.travelDate?.fromDate) > moment() ? moment(this.booking?.commonOffer?.hotelOffer?.travelDate?.fromDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
                end: moment(this.booking?.commonOffer?.hotelOffer?.travelDate?.toDate).format('YYYY-MM-DD'),
                minDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration,
                maxDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration
            };
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt(this.booking?.realparams) }
            };
            const url = this.router.createUrlTree(['offers'], navigationExtras).toString();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('visibility', 'hidden');
            link.click();
        } else if (sktvContent?.orderId?.length > 0) {
            const realparams = {} as ParamFilters;
            const dateFirst = sktvContent.depart?.first?.length > 0 ? sktvContent.depart.first : '';
            const dateLast = sktvContent.depart?.last?.length > 0 ? sktvContent.depart.last : '';
            realparams.reference = this.reference()?.length > 0 ? this.reference() : 'offerpack';
            realparams.reisezeitraumResult = {
                start: moment(dateFirst) > moment() ? moment(dateFirst).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
                end: moment(dateLast).format('YYYY-MM-DD'),
                minDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration,
                maxDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration
            };
            realparams.extra = {
                orderId: sktvContent?.orderId,
                seller: sktvContent?.organizer
            }
            realparams.reisedauerResult = {
                name: sktvContent.durationforsearch > 0 ? String(sktvContent.durationforsearch) + ' Tage' : 'Beliebig',
                minDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration,
                maxDuration: this.booking?.commonOffer?.hotelOffer?.travelDate?.duration
            };
            realparams.reisendeResult = {
                children: [],
                adults: 2,
            }
            realparams.productType = sktvContent.producttypeforsearch?.length > 0 ? sktvContent.producttypeforsearch : 'pauschal';
            const tmporg = sktvContent?.organizer?.split(',');
            const to_code = tmporg?.length > 0 ? tmporg[0] + '_' + sktvContent.bookingcode : sktvContent.bookingcode;

            realparams.pauschalreiseResult = {
                data: {
                    name: sktvContent.name,
                    code: to_code
                },
                type: 1,
            };
            realparams.tourOperatorList = [];
            if (sktvContent.organizer?.length > 0) {
                const tmp_ops = sktvContent?.organizer?.split(',');
                for (let i = 0; i < tmp_ops?.length; i++) {
                    realparams.tourOperatorList.push({
                        code: tmp_ops[i],
                        name: ''
                    });
                }
            }
            if (sktvContent.hidden_op?.length > 0) {
                realparams.tourOperatorList.push({
                    code: sktvContent.hidden_op,
                    name: ''
                });
            }
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt(realparams) }
            };
            const url = this.router.createUrlTree(['offers'], navigationExtras).toString();
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('visibility', 'hidden');
            link.click();
        }
    }

    async openImageModal(ev) {
        const target = {
            disableClose: true,
            height: '100%',
            width: '100%',
            panelClass: ['full-screen-modal'],
            data: {
                hotel: null,
                images: this.sktvContent().images,
                videos: [],
                current: ev,
                to800: false,
                desktopTemplate: this.desktopTemplate,
                showSave: true
            }
        }
        const resf = this.dialog.open(TvangebotimagevideoComponent, target);
        resf.afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((pos) => {
            if (pos !== this.firstBilderPos) {
                this.firstBilderPos = pos;
                this.saveImagesList(pos);
            }
        });
    }

    async openFluginfo() {
        const target = { data: { offer: this.offer }, autoFocus: false };
        this.dialog.open(FlugDetailComponent, target);
    }

    saveImagesList(pos) {
        this.saveImagePos.emit(pos);
    }

    async openDetail() {
        if (this.component) {
            this.component.destroy();
        }
        this.sendRegSub?.unsubscribe();
        this.component = this.viewContainerRef.createComponent(SktvDetailComponent);
        this.component.instance.booking = this.booking;
        this.component.instance.sktvContent = this.sktvContent();
        this.sendRegSub = this.component.instance.sendAlt.subscribe((ev) => {
            if (ev) {
                this.gotoOffers();
            }
        });
        this.sendBook = this.component.instance.sendBook.subscribe((ev) => {
            if (ev) {
                this.goToBooking();
            }
        });
        this.showDetail = true;
        this.cdr.detectChanges();
    }

    closeModal(ev) {
        if (ev) {
            this.showDetail = false;
            this.cdr.detectChanges();
        }
    }

    async dragStart(ev: DragEvent, index: number) {
        ev.stopPropagation();
        ev.dataTransfer.effectAllowed = 'move';
        ev.dataTransfer.setData('dragedindex', index + '');
    };

    async dragOver(event: DragEvent) {
        event.preventDefault();
    }

    async dropp(ev: DragEvent) {
        ev.stopPropagation();
        const dragedindex = ev.dataTransfer.getData('dragedindex')
        const index = this.index();
        if (Number(dragedindex) > 0 && Number(dragedindex) !== index) {
            this.changeindex.emit({ dragedindex: Number(dragedindex) - 1, dropindex: index - 1 });
        }
    }
}
